import type { TrackAssessmentResult } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

const EXCLUDED_KEYS = new Set([
  'uuid',
  'user_id',
  'academic_grade_id',
  'career_track_id',
  'academic_rigor_id',
  'profile_image_url',
  'resume_media_id',
  'transcript_media_id',
  'career_user_response_set_id',
  'updated_at',
]);

export const useAgentContext = (data?: TrackAssessmentResult) => {
  useRegisterAgentContext(
    data
      ? {
          kind: 'entity',
          description: 'Career track assessment result',
          data: Object.fromEntries(Object.entries(data).filter(([k]) => !EXCLUDED_KEYS.has(k))),
        }
      : null,
  );
};
